export const ROLE_MAPPING = {
    'business': '商务',
    'director': '主管',
    'financial': '财务',
    'customer': '客户'
};

export const NOTIFICATION_TYPE_MAPPING = {
    'MARKETING': '营销需求',
    'MAINTENANCE': '系统维护'
}

export const STATUS_TEXT_MAPPING = {
    'SENT': '已发送',
    'PENDING': '待发送'
};